/*
 * $Id:: draftApplicationsSlice.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { createSlice } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';

export const slice = createSlice({
    name: SLICE_NAME,
    initialState: {
        list: null,
        error: null,
        loading: false,
        exportLoading: false,
    },
    reducers: {
        list: (state, action) => {
            state.list = action.payload;
        },
        loading: (state, action) => {
            state.loading = action.payload;
        },
        exportLoading: (state, action) => {
            state.exportLoading = action.payload;
        },
        error: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const list = (state) => state[SLICE_NAME].list;
export const loading = (state) => state[SLICE_NAME].loading;
export const exportLoading = (state) => state[SLICE_NAME].exportLoading;
export const error = (state) => state[SLICE_NAME].error;
export default slice.reducer;
